<template>
  <div class="imprint-content">
    <h1>{{ $t("labels.imprint") }}</h1>
    <div class="imprint-content__columns">
      <p v-if="locale != 'de'" class="mb-6">
        {{ $t("imprint.requiredByLaw") }}
      </p>
      <p>
        {{ $t("texts.simcisionIsByIcondu") }}
      </p>
      <p>
        {{ $t("texts.modelByModelAuthor") }}
      </p>
      <p v-if="modelAuthor">
        {{ $t("labels.modelAuthor") }}{{ $t(":") }} {{ modelAuthor }}
      </p>
      <section class="imprint-content__section">
        <h2 class="subtitle">
          {{ $t("imprint.responsibleForContent") }}
        </h2>
        <p>{{ $t("imprint.tmg5") }}</p>
        <p>
          iCONDU GmbH<br />
          Milchstraße 14<br />
          85049 Ingolstadt<br />
        </p>
      </section>

      <section class="imprint-content__section">
        <h2 class="subtitle">
          {{ $t("imprint.representedBy") }}
        </h2>
        <p>Dr. Michael Holzner</p>
      </section>

      <section class="imprint-content__section">
        <h2 class="subtitle">
          {{ $t("headings.contact") }}
        </h2>
        <p>
          {{ $t("labels.telephone") }}{{ $t(":") }} +49 (0) 841-99 47 68 55
          <br />
          {{ $t("labels.email") }}{{ $t(":") }} info@icondu.de<br />
        </p>
      </section>

      <section class="imprint-content__section">
        <h2 class="subtitle">
          {{ $t("imprint.registryEntry") }}
        </h2>
        <p>
          {{ $t("imprint.commercialRegister") }}<br />
          {{ $t("imprint.registerCourt") }}{{ $t(":") }} Ingolstadt<br />
          {{ $t("imprint.registrationNumber") }}{{ $t(":") }} HRB 6004<br />
        </p>
      </section>

      <section class="imprint-content__section">
        <h2 class="subtitle">
          {{ $t("imprint.vatID") }}
        </h2>
        <p>
          {{ $t("imprint.vatIDaccordingToLaw") }}<br />
          DE275779379
        </p>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useProjectStore } from "@editor/store/project.store";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const modelAuthor = computed(() => {
  return useProjectStore().author;
});
</script>

<style lang="scss">
.imprint-content {
  &__columns {
    max-width: 50rem;
    @media screen and (min-width: 720px) {
      column-count: 2;
    }
  }

  &__section {
    break-inside: avoid;
  }
}
</style>
